// @flow

import {Tag, isMarkdocAstTag} from 'docs/util';

import type {RenderNode as MarkdocRenderNode} from '@markdoc/markdoc';
import type {MarkdocTagRegistration} from 'docs/markdoc';

const parseOptions = (children: Array<MarkdocRenderNode | string>) => {
  return children.map((tag) => {
    if (!isMarkdocAstTag(tag)) {
      throw Error('Invalid child of advanced-page-selector');
    }
    return {
      children: parseOptions((tag.children: any)),
      prefs: tag.attributes.prefs,
      title: tag.attributes.title,
    };
  });
};

export const AdvancedPageSelector: MarkdocTagRegistration = {
  tag: 'advanced-page-selector',
  component: 'AdvancedPageSelector',
  attributes: {},
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);

    const children = node.renderChildren(config);
    const options = parseOptions(children);

    return new Tag(this.tag, {...attributes, options});
  },
};
